import { render, staticRenderFns } from "./posteditor.vue?vue&type=template&id=27a2b652&scoped=true&"
import script from "./posteditor.vue?vue&type=script&lang=js&"
export * from "./posteditor.vue?vue&type=script&lang=js&"
import style0 from "./posteditor.vue?vue&type=style&index=0&id=27a2b652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2b652",
  null
  
)

export default component.exports